import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoadingScreen from "../../shared/LoadingScreen/LoadingScreen";

export default function ChamUpload() {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.querySelector("im-upload").addEventListener("upload", function () {
            if(document.getElementById("imgInp").value !== ""){
                setIsLoading(true);
            } 
          });
          
          document.getElementById('imgToUpload').addEventListener('load', function(){ // Goes straight to visualizer
            document.querySelector('#upload-section .btn-upload').click();
            setIsLoading(false);
          });
    }, []);

    return(
        <>
            <im-upload title="Upload My Own Photo" calltoaction="Start Your Project" active="0" postpage="IM.aspx"></im-upload>
            <LoadingScreen 
                isOpen={isLoading}
                message="Processing your image..."
                variant="spinner"
            />
        </>
    );
}

export function ChamUploadButton({className, title, onClick}) {

    const handleClick = function() {
        // Save current URL to local storage
        localStorage.setItem('current_selection', window.location.href);
        
        // Call the optional onClick callback (e.g., to close menu)
        if (onClick) {
            onClick();
        }
        
        // Trigger the upload button
        document.querySelector(".uploaderBTN").click();
    }

    return(
        <button onClick={handleClick} className={className}>{title}</button>
    )
}